<template>
	<div>
			<div class="container container--small pdt-50 pdb-50">
				<div class="t-headline11 font-m mgb-8 pdl-24 pdr-24">{{$t('1625')}}</div>
				<div class="t-body1 t-color-bodyGrayA font-r pdl-24 pdr-24">{{$t('1626')}}</div>
				<form @submit.prevent="next()" novalidate>
				<div class="pdl-24 pdr-24">
					<div class="mgt-40">
						<label
							class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
							data-mdc-auto-init="MDCTextField" 
								:class="submitState && emailInvalidCheck ? 'mdc-text-field--invalid--custom mdc-text-field--invalid' : ''"
								id="emailEl"
							>
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
									<span class="mdc-floating-label" id="my-label-id">{{$t('1627')}}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
							<input class="mdc-text-field__input t-body6" 
									v-model="email"
									v-validate="'required|email'"
									ref="email"
									id="email"
									name="email"
									maxlength="50"
								/>
							<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
								role="button" 
								:class="validIcon === 'check' ? 'check_show' : ''"
								>{{validIcon}}</i>
								<!-- <i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
								role="button">report_problem</i> -->
						</label>
						<div class="mdc-text-field-helper-line d-block">
							<div
								class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r "
								v-show="submitState && emailInvalidCheck">
								{{$t('1630')}}
							</div>
							<div
								class="mdc-text-field-helper-text t-color-textfieldActive mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r "
								v-show="!(submitState && emailInvalidCheck)">
							{{$t('823')}}
							</div>
						</div>
					</div>

					<div class="mgt-30 mgb-50">
						<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{$t('1628')}}</span>
						</button>
						<button class="mdc-button t-color-secondaryBtnText b-radius4 " @click="cancelJoin()" @keypress="cancelJoin()" tabindex="0">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{$t('1613')}}</span>
						</button>
					</div>
				</div>
				</form>
			</div>
	</div>
</template>

<script>
/**
 * 회원가입 - 아이디 입력(sign up - input email component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import joinApi from '@/api/joinApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

export default {
	data() {
		return {
			email: '',
			emailTextField: null,
			submitState: false,
			validIcon: 'report_problem'
		}
	},

	mixins: [joinMixin],

	computed : {
		...mapState('join',{
			join : state => state,
		}),
	   
		// email 유효성 Check 및 아이콘(validation email & set icon)
		emailInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('email')) {
					returnValue = true
					this.validIcon = 'report_problem'
				}else {
					returnValue = false
					this.validIcon = 'check'
				}
			}
			this.emailTextField.valid === !returnValue ? '' : this.emailTextField.valid = !returnValue
			return returnValue
		},

	},
	
	created() {
		if (!this.join.responsibility || !this.join.terms.TERMS_OF_SERVICE || !this.join.name.first || !this.join.name.last) {
		 this.moveJoin2Intro()
		}
	},
	

	mounted() {
		this.setMaterialUi()
		this.$refs.email.focus()
	},

	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('join', ['SET_LOGINID']),

		setMaterialUi() {
			this.emailTextField = new MDCTextField(document.querySelector('#emailEl'))
			this.emailTextField.useNativeValidation = false
					window.mdc.autoInit();
				if(document.querySelector('.mdc-tab-bar')){
					var tabBar = new mdc.tabBar.MDCTabBar(document.querySelector('.mdc-tab-bar'));
				}
				if(document.querySelector('.mdc-text-field')){
					var textField = new MDCTextField(document.querySelector('.mdc-text-field'));
				}
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
			this.email = this.join.loginId
			this.emailTextField.value = this.email
			
		},

		next() {
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				if (resultValid) {
					let params = { userId: this.email }
					// id duplicate check
					joinApi.existsId(params).then((response) => {
						if (response.data.data) {
							let params = {
								// title:'이미 가입된 이메일',
								// content: '이미 가입된 이메일 계정입니다.로그인하거나 이메일 확인 후 다시 입력하세요.',
								// accept: '확인',
								// cancel: '로그인하기'
								title: this.$t('1641'),
								content: this.$t('1642') + ' ' + this.$t('1643'),
								accept: this.$t('1645'),
								cancel: this.$t('1644')
							}
							this.$confirm(params).then(() => {
								this.email = ''
							}).catch(() => {
								this.$moveLogin()
							})
						} else {
						//	console.log(this.email);
							this.SET_LOGINID(this.email)
							this.$router.push({name: 'Join2Password'})
						}
					}).catch((err) => {
						
					})
					
				} else{
				//	this.focusFirstInvalidElement()
				}
			})
		}
	},
}
</script>
<style scoped>
.check_show{
	display: block !important;;
}
</style>